<template>
  <v-layout :class="styles" column>
    <v-menu transition="slide-y-transition" top>
      <template v-slot:activator="{ on }">
        <p class="ma-0 px-4">
          <a v-on="on" class="incidentTitle">
            【障害情報】レポート情報の遅延について
          </a>
        </p>
      </template>
      <v-card class="pa-2" style="width: 500px">
        <v-subheader :class="[headerStyles, 'px-2']">
          【障害情報】レポート情報の遅延について
        </v-subheader>
        <p class="ma-2 incidentRestorationTitle">
          管理画面において、6月16日以降のレポートデータの一部に欠損が発生しており、正しい数値が表示されない事象が発生しております。<br />
          現在、原因の調査およびレポートの復旧作業を進めております。<br />
          ご迷惑をおかけしており、誠に申し訳ございません。
        </p>
        <AppButtonOk small>閉じる</AppButtonOk>
      </v-card>
    </v-menu>
  </v-layout>
</template>

<script>
import { css } from 'emotion'
export default {
  name: 'HolidaysInformation',
  computed: {
    styles() {
      return css`
        display: flex;
        align-items: flex-start;
        justify-content: center;
        font-size: 12px;
        overflow: hidden;
      `
    },
    headerStyles() {
      return css`
        font-size: 16px !important;
      `
    },
  },
  methods: {
    onClick() {
      this.$emit('onClick')
    },
  },
}
</script>
<style>
.incidentTitle {
  color: #ff4500 !important;
  font-size: 14px;
}
.incidentRecoveryTitle {
  color: #1976d2 !important;
  font-size: 14px;
}
.incidentRestorationTitle {
  font-size: 14px;
}
.incidentContent {
  font-size: 14px;
}
</style>
